import React from 'react'
import { Link } from "react-router-dom";
import { CopyToClipboard } from 'react-copy-to-clipboard'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import EmptyListUI from '../../../widgets/output/EmptyListUI'
import SpinnerUI from '../../../widgets/output/SpinnerUI'
import ButtonUI from '../../../widgets/action/ButtonUI'
import SearchUI from '../../../widgets/input/SearchUI'
import SelectUI from '../../../widgets/input/SelectUI'
import BadgeUI from '../../../widgets/output/BadgeUI'
import NodalTxnRemarksModalSF from './NodalTxnRemarksModalSF'

const ReconTxnListUI = ({ context, transactionList, onRefreshClick, selectedTxnId,
  accountNumber, 
  year, month, yearList, monthList, onYearChange, onMonthChange,
  searchFilter, onSearchFilterChange, onCopyToClipboard, copyToClipboardText,
  onExternalClick, externalSubmitted,
  onCancelledClick, cancelledSubmitted,
  onUpdateRemarksClick, details, onDetailsClick,
  updateRemarksMode, onCancelRemarksClick, transactionId, reconciliationStatus, selectedRemarks, nodalExtTxnTypeList,
}) =>
  <div className='su_ntxn'>
    <LRTableActionsUI location='top'
      left={
        <ActionLeftUI
          context={context}
          onRefreshClick={onRefreshClick}
          accountNumber={accountNumber}
        />
      }
      right={
        <ActionRightUI
          context={context}
          yearList={yearList} monthList={monthList}
          year={year} month={month}
          onYearChange={onYearChange} onMonthChange={onMonthChange}
          searchFilter={searchFilter}
          onSearchFilterChange={onSearchFilterChange}
        />
      }
    />

    <div className='g_muted g_flex_h'>
      <i>{transactionList.length} transaction{transactionList.length == 1 ? '' : 's'} displayed</i>
      {/*<span className='g_muted'><i>Search by account name, narration, type</i></span>*/}
    </div>

    {/*
      transactionList.length > 0 &&
      <div className='g_flex_h g_m_bottom_25'>
        <Link to='#' onClick={onDetailsClick}>Details</Link>
      </div>
    */}
    {
      transactionList.length > 0 &&
      <table><tbody>
        <tr>
          <th colSpan='3' className='g_ultra_muted_bg'>Bank Statement Transactions</th>
          <th className='g_p_left_50' />
          <th colSpan='3' className='g_ultra_muted_bg'>Escrow Accounts Transactions</th>
        </tr>
        {
          transactionList.map((txn, i) =>
            <TxnRowList key={i} context={context} txn={txn}
              selectedTxnId={selectedTxnId}
              onCopyToClipboard={onCopyToClipboard} copyToClipboardText={copyToClipboardText}
              onExternalClick={onExternalClick} externalSubmitted={externalSubmitted}
              onCancelledClick={onCancelledClick} cancelledSubmitted={cancelledSubmitted}
              onUpdateRemarksClick={onUpdateRemarksClick} details={details}
            />
          )
        }
      </tbody></table>
    }
    {
      transactionList.length === 0 &&
      <EmptyListUI
        context={context} className='g_m_top_200'
        createEnabled={false}
        createDisabledMessageLabel='No transactions'
      />
    }

    <NodalTxnRemarksModalSF context={context} accountNumber={accountNumber}
      updateMode={updateRemarksMode} onCancelClick={onCancelRemarksClick}
      onRefreshClick={onRefreshClick} transactionId={transactionId}
      reconciliationStatus={reconciliationStatus}
      selectedRemarks={selectedRemarks} nodalExtTxnTypeList={nodalExtTxnTypeList}
    />
  </div>

const TxnRowList = ({ context, txn, selectedTxnId, onCopyToClipboard, copyToClipboardText,
  onExternalClick, externalSubmitted, onCancelledClick, cancelledSubmitted,
  onUpdateRemarksClick, details
}) =>
  <tr className='g_small'>
    <td className={`g_text_top g_small g_no_wrap_2 ${txn.virtualAmountF5 ? '' : txn.climeTxnType ? 'g_info' : 'g_error'}`}>
      {txn.nodalTransactionDateF1}
    </td>
    <td className={`g_text_top g_p_left_50 g_small ${txn.virtualAmountF5 ? '' : txn.climeTxnType ? 'g_info' : 'g_error'}`}>
      <RowLeftUI context={context} txn={txn} details={details}
        onCopyToClipboard={onCopyToClipboard} copyToClipboardText={copyToClipboardText}
        onUpdateRemarksClick={onUpdateRemarksClick}
      />
      <RemarksUI context={context} txn={txn} selectedTxnId={selectedTxnId} details={details}
        onExternalClick={onExternalClick} externalSubmitted={externalSubmitted}
        onCancelledClick={onCancelledClick} cancelledSubmitted={cancelledSubmitted}
      />
    </td>
    <td className={`g_text_top g_text_right g_p_left_50 g_small ${txn.virtualAmountF5 ? '' : txn.climeTxnType ? 'g_info' : 'g_error'}`}>
      {
        txn.nodalAmount >= 0 &&
        <>{txn.nodalAmountF5}</>
      }
      {
        txn.nodalAmount < 0 &&
        <>({txn.nodalAmountF5})</>
      }
    </td>
    <td className={`g_p_left_50`} />
    <td className={`g_text_top ${txn.nodalAmountF5 ? '' : 'g_error'}`}>
      {txn.virtualNarration}
    </td>
    <td className={`g_text_top g_text_right g_p_left_50 g_small ${txn.nodalAmountF5 ? '' : 'g_error'}`}>
      {
        txn.virtualAmount >= 0 &&
        <span>{txn.virtualAmountF5}</span>
      }
      {
        txn.virtualAmount < 0 &&
        <span>({txn.virtualAmountF5})</span>
      }
    </td>
    <td className={`g_text_top g_p_left_50 g_small g_no_wrap_2 ${txn.nodalAmountF5 ? '' : 'g_error'}`}>
      {txn.virtualTransactionDateF1}
    </td>
  </tr>

const RowLeftUI = ({ txn, onCopyToClipboard, copyToClipboardText, details, onUpdateRemarksClick }) =>
  <span className='g_flex_v'>
    <span className='particulars'>
      {txn.nodalParticulars}
      {
        details &&
        <span className="icon icon-pencil g_m_left_50 g_cursor_pointer g_muted"
          onClick={onUpdateRemarksClick} data-transaction-id={txn.iciciTransactionId}
          data-recon-status={txn.reconciliationStatus}
        />
      }
    </span>
    {
      details &&
      <>
        <span className='g_muted'>{txn.remarks}</span>
        <span className='g_muted'>{txn.depositBranch}</span>
        <span className=''>
          <span className='g_muted'>{txn.iciciTransactionId}</span>
          <span onClick={e => e.stopPropagation()}>
            <CopyToClipboard text={txn.iciciTransactionId}
              onCopy={onCopyToClipboard}>
              <span className='g_m_left_50 g_muted icon icon-clone g_cursor_pointer' />
            </CopyToClipboard>
            {
              copyToClipboardText === txn.iciciTransactionId &&
              <span className='g_m_left_50 g_muted'>copied</span>
            }
          </span>
        </span>
        {
          (txn.escrowAccountNumber || txn.appTxnId) &&
          <span className='g_muted'>
            Escrow a/c: {txn.escrowAccountNumber}
            <span className='g_m_left_50'>{txn.appTxnId}</span>
          </span>
        }
        {
          txn.loanId &&
          <span className='g_muted g_small'>Loan: {txn.loanId} {txn.loanName}</span>
        }
      </>
    }
    <span className='g_flex_h g_flex_left'>
      {
        txn.type &&
        <BadgeUI label={txn.type} />
      }
      {
        txn.reconciliationStatus === 'cancelled' &&
        <BadgeUI label={txn.reconciliationStatus} />
      }
      {
        txn.climeTxnType &&
        <BadgeUI label={txn.climeTxnType} />
      }
      {
        txn.type &&
        <span className='g_m_left_100'>
          <span className=''><b>{txn.accountName}</b></span>
          {
            txn.remitter &&
            <span className='g_m_left_50 icon icon-angle-left'> {txn.remitter}</span>
          }
          {
            txn.payee &&
            <span className='g_m_left_50 icon icon-angle-right'> {txn.payee}</span>
          }
        </span>
      }
    </span>
    {
      txn.internalRemarks &&
      <span className='g_info'>Remarks: {txn.internalRemarks}</span>
    }
  </span>

const RemarksUI = ({ context, txn, selectedTxnId, details, onCancelledClick, cancelledSubmitted }) =>
  <div className='g_flex_v g_text_right'>
    <span className='g_flex_h g_flex_right'>
      {
        context.permissions.includes('su_superuser') &&
        txn.reconciliationStatus && txn.reconciliationStatus === 'reconcile_failed' &&
        <span className='g_flex_h'>
          <SpinnerUI show={cancelledSubmitted && txn.iciciTransactionId === selectedTxnId} reserveSpace={true} />
          {
            details &&
            <ButtonUI label='Mark Cancelled' transparent={true}
              onClick={onCancelledClick} dataId={txn.iciciTransactionId} />
          }
        </span>
      }
      {
        txn.reconciliationStatus && txn.reconciliationStatus !== 'reconcile_success' &&
        txn.reconciliationStatus !== 'external_transfer' &&
        txn.reconciliationStatus !== 'cancelled' &&
        <BadgeUI label={txn.reconciliationStatus} />
      }
    </span>
  </div>

const ActionLeftUI = ({ onRefreshClick, accountNumber }) =>
  <div className='g_flex_h'>
    <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
    <span className='g_m_left_100 g_large'><b>Reconciliations in {accountNumber}</b></span>
  </div>

const ActionRightUI = ({ year, month, yearList, monthList, onYearChange, onMonthChange, searchFilter, onSearchFilterChange }) =>
  <div className='g_flex_h'>
    <SelectUI selectedKey={year} optionList={yearList} onChange={onYearChange} placeholder='Year' />
    <SelectUI selectedKey={month} optionList={monthList} onChange={onMonthChange} placeholder='Month' />
    {/*<SearchUI value={searchFilter} onChange={onSearchFilterChange} />*/}
  </div>

export default ReconTxnListUI
